module.exports = __webpack_public_path__ + "img/quote-start.a52d4e0e.svg";